<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <path
      d="M25.8933 13.688C25.5528 13.2792 25.1485 12.9549 24.7036 12.7337C24.2586 12.5124 23.7817 12.3986 23.3 12.3986C22.8183 12.3986 22.3414 12.5124 21.8964 12.7337C21.4515 12.9549 21.0472 13.2792 20.7067 13.688L20 14.536L19.2933 13.688C18.6055 12.8627 17.6727 12.399 16.7 12.399C15.7273 12.399 14.7945 12.8627 14.1067 13.688C13.4189 14.5134 13.0325 15.6328 13.0325 16.8C13.0325 17.9672 13.4189 19.0867 14.1067 19.912L14.8133 20.76L20 26.984L25.1867 20.76L25.8933 19.912C26.234 19.5034 26.5042 19.0183 26.6886 18.4843C26.873 17.9503 26.9679 17.378 26.9679 16.8C26.9679 16.222 26.873 15.6497 26.6886 15.1157C26.5042 14.5818 26.234 14.0966 25.8933 13.688V13.688Z"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
